import { getLuminance } from "@material-ui/core/styles/colorManipulator"

export const checkColorShade = color => {
    const luminance = getLuminance(color)
    if (luminance < 0.5) {
        return "#FFFFFF"
    }
    return "#111111"
}
